import { render } from "./TeachDateView.vue?vue&type=template&id=3286f2c2&scoped=true"
import script from "./TeachDateView.vue?vue&type=script&lang=js"
export * from "./TeachDateView.vue?vue&type=script&lang=js"

import "./TeachDateView.vue?vue&type=style&index=0&id=3286f2c2&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3286f2c2"]])

export default __exports__